import React from "react";
import { styled } from "@linaria/react";
import formatNumber from "../i18n/formatNumber";
import { colors, fonts } from "../Theme";
interface P extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  value: number | undefined | null;
  precision?: number;
  suffix?: string;
  size?: "large" | "small";
  sign?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.div`
  font: ${fonts.body1};
  color: ${colors.carbon700};
`;

const ValueWrapper = styled.div`
  font-weight: 600;
`;

/* NOTE: MISSING SCALE */
const Value = styled.span`
  font: ${fonts.h1};
  color: ${colors.carbon900};
  &.small {
    font: ${fonts.h2};
  }
`;

const Suffix = styled.span`
  font: ${fonts.h3};
  color: ${colors.carbon900};
  margin-left: 5px;
  &.small {
    font: ${fonts.h4};
  }
`;

function Statistic({ className, title, value, precision, sign, suffix, size, ...props }: P) {
  return (
    <Wrapper className={className} {...props}>
      <Title>{title}</Title>
      <ValueWrapper>
        <Value className={size}>
          {value === null || value === undefined ? "-" : formatNumber(value, { precision, sign })}
        </Value>
        {suffix && <Suffix className={size}>{suffix}</Suffix>}
      </ValueWrapper>
    </Wrapper>
  );
}

export default Statistic;
